import { Component } from '@theme/component';

/**
 * @typedef {Object} TabsRefs
 * @property {HTMLElement[]} tabButtons
 * @property {HTMLElement[]} tabContents
 * @property {HTMLSelectElement} tabSelect
 */

/**
 * A custom element that manages the showing and hiding excess content items
 *
 * @extends {Component<TabsRefs>}
 */

class TabsComponent extends Component {
  requiredRefs = ['tabButtons', 'tabContents'];
  
  connectedCallback() {
    super.connectedCallback();

    this.checkActiveContent()
  }

  checkActiveContent() {
    const { tabContents } = this.refs;
    
    const activeContent = tabContents.find(_content => _content.classList.contains('active'));
    if (typeof activeContent === 'undefined') {
      tabContents[0]?.classList.add('active');
    }
  }

  /**
   * Show tab content
   * @param {{ target: HTMLElement; }} event
   */
  showContent(event) {
    const { tabButtons, tabContents } = this.refs
    tabButtons.forEach((tab, index) => {
      if(event.target === tab) {
        tab.classList.add('active');
        // @ts-ignore
        tabContents[index].classList.add('active');
      } else {
        tab.classList.remove('active');
        // @ts-ignore
        tabContents[index].classList.remove('active');
      }
    })
  }

  changeContent() {
    const { tabSelect, tabContents } = this.refs
    const selectedIndex = Number(tabSelect.value)
    tabContents.forEach((content, index) => {
      if(index === selectedIndex) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    })
  }
}

if (!customElements.get('tabs-component')) {
  customElements.define('tabs-component', TabsComponent);
}
